import Typography from '../Atoms/Typography';
import LostInSpaceGif from '../../assets/images/lost-in-space.gif';
import { openZohoSalesIqChat } from '../../utils/common';

function ErrorPage() {
  return (
    <div className="ltw-flex ltw-flex-col ltw-items-center ltw-gap-84px ltw-my-84px">
      <div className="ltw-flex ltw-flex-col ltw-items-center">
        <img src={LostInSpaceGif} alt="lost page" width={370} height={270} />
        <Typography
          variant="h2"
          fontType="ltw-font-bold"
          color="ltw-text-secondary"
          fontSize="ltw-text-22"
          lineHeight="ltw-leading-27"
          mt="20px"
        >
          This page is lost in space!
        </Typography>
        <Typography
          variant="h2"
          fontType="ltw-font-normal"
          color="ltw-text-black-secondary"
          fontSize="ltw-text-12"
          lineHeight="ltw-leading-16"
        >
          We can’t find what you’re looking for, but the links below may help.
        </Typography>
        <a
          href="/"
          className="ltw-flex ltw-bg-primary ltw-rounded ltw-px-10px ltw-py-8px ltw-cursor-pointer ltw-mt-25px"
        >
          <Typography
            variant="h2"
            color="ltw-text-white"
            fontSize="ltw-text-13"
            lineHeight="ltw-leading-16"
            cursor="pointer"
            fontType="ltw-font-semibold"
          >
            Go to Hyperexecute Homepage
          </Typography>
        </a>
      </div>
      <div className="ltw-flex ltw-items-center ltw-gap-130px">
        <div>
          <Typography
            variant="h2"
            fontType="ltw-font-normal"
            color="ltw-text-gray-12"
            fontSize="ltw-text-14"
            lineHeight="ltw-leading-19"
            mb="25px"
          >
            Support articles,videos and suggested way to use
          </Typography>
          <a
            href={process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK}
            target="__blank"
          >
            <Typography
              variant="h2"
              fontType="ltw-font-medium"
              color="ltw-text-blue-link"
              fontSize="ltw-text-14"
              lineHeight="ltw-leading-17"
              cursor="poniter"
            >
              View the Docs
            </Typography>
          </a>
        </div>
        <div>
          <Typography
            variant="h2"
            fontType="ltw-font-normal"
            color="ltw-text-gray-12"
            fontSize="ltw-text-14"
            lineHeight="ltw-leading-19"
            mb="25px"
          >
            News and updates from the Lambdatest team
          </Typography>
          <a
            href={'https://www.lambdatest.com/blog/category/hyperexecute/'}
            target="__blank"
          >
            <Typography
              variant="h2"
              fontType="ltw-font-medium"
              color="ltw-text-blue-link"
              fontSize="ltw-text-14"
              lineHeight="ltw-leading-17"
              cursor="poniter"
            >
              Read our Blog
            </Typography>
          </a>
        </div>
        <div>
          <Typography
            variant="h2"
            fontType="ltw-font-normal"
            color="ltw-text-gray-12"
            fontSize="ltw-text-14"
            lineHeight="ltw-leading-19"
            mb="25px"
          >
            Let our experts show you LambdaTest in action!
          </Typography>
          <button onClick={openZohoSalesIqChat}>
            <Typography
              variant="h2"
              fontType="ltw-font-medium"
              color="ltw-text-blue-link"
              fontSize="ltw-text-14"
              lineHeight="ltw-leading-17"
              cursor="poniter"
            >
              Contact Support
            </Typography>
          </button>
        </div>
      </div>
    </div>
  );
}
export default ErrorPage;
